import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
const WarningMessage = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            p: 2,
            borderRadius: 2,
            backgroundColor: theme.palette.primary.light + '20',
            color: theme.palette.primary.darker,
            border: `1px solid ${theme.palette.primary.light + '40'}`
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    backgroundColor: theme.palette.info.main,
                    flexShrink: 0,
                    mt: 0.25
                }, children: _jsx(Typography, { variant: 'body2', sx: {
                        color: theme.palette.common.white,
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: 1
                    }, children: "i" }) }), _jsx(Typography, { variant: 'body2', sx: {
                    color: theme.palette.primary.darker,
                    fontSize: '14px',
                    lineHeight: 1.4
                }, children: t('validations.stepHasNoQuestions') })] }));
};
export default WarningMessage;
